import * as React from 'react';

const StarFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2L9.2 9.5H2l5.5 5-2 7.5 6.5-4.3 6.5 4.3-2-7.5 5.5-5h-7.2z"
        />
    </svg>
);

StarFillSvg.displayName = 'StarFillSvg';
export default StarFillSvg;
